<div class="container">

	<div class="portalCard">


		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>close_fullscreen</mat-icon>
				<span>Austausch erstellen</span>
			</div>

			<mat-spinner diameter=30 *ngIf="bLoading || bUploading" />

		</div>

		<div>

			@if( bLoading ) {
				<mat-progress-bar mode="indeterminate" />
			}
			@else if( bLoadingError ) {
				<h4 style="text-align: center; color: red;">
					Beim Laden der Daten ist ein Fehler aufgetreten
				</h4>
			}
			@else {

				<div class="creationContainer">

					<div
						style="display: flex; flex-flow: column wrap; gap: 2em; justify-content: center;"
						[formGroup]="creationFormGroup"
					>

						@if( bAdmin ) {

							<mat-form-field appearance="outline">
								<mat-label>Mitglied</mat-label>
								<mat-select formControlName="member" multiple>
									@for( member of members; track member.mitgliedId ) {
										<mat-option [value]="member.mitgliedId">
											{{member.mitgliedsname}} 
											@if( !member.mitgliedsname ) {
												<span>
													({{member.mitgliedId}})
												</span>
											}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>

						}
	
						<mat-form-field appearance="outline">
							<mat-label>Kategorie</mat-label>
							<mat-select formControlName="category">
								@for( categ of documentExchangeCategories; track categ.id ) {
									<mat-option [value]="categ.id">
										{{categ.name}}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>


						<mat-form-field appearance="outline">
							<mat-label>Beschreibung</mat-label>
							<input
								matInput
								formControlName="description"
							>
						</mat-form-field>

						<div style="border: 1px solid #0000008f; border-radius: 5px">

							<triv-input
								[fGroup]="creationFormGroup"
								[data]="fileDataInput" 
								(filesChosen)="onFilesChosen($event)"
							/>

						</div>

						<div class="fileGrid">
							@for( myFile of myFiles; track myFile.id ) {
								<ng-container *ngIf="myFile.file">
									<div [title]="myFile.file.name">
										{{ myFile.file.name | shortenMiddle:50 }}
									</div>
									<div>
										<span
											(click)="removeFile(myFile)"
											class="material-icons iconBtn"
											[title]="'Löschen ' + myFile.file.name"
										>clear</span>
									</div>
								</ng-container>
							}
						</div>

						<button 
							mat-raised-button
							color="primary" 
							[disabled]="bLoading || bUploading || !creationFormGroup.valid"
							(click)="upload()"
						>
							Erstellen
						</button>

						<mat-progress-bar *ngIf="bUploading" mode="indeterminate" />

						<div *ngIf="bUploadError" class="errorMessage">
							Beim Hochladen ist ein Fehler aufgetreten
						</div>

					</div>

				</div>

			}

		</div>

	</div>

</div>
